import React from "react"

function Umbrella({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5241 12.9688C14.4175 13.078 12.4165 14.9196 12.0406 17.3694"
        stroke="#003E4C"
        strokeWidth="1.00404"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9997 7.27051V9.36839"
        stroke="#003E4C"
        strokeWidth="1.0061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9872 21.5161V27.6807C17.5039 29.0275 15.6776 29.1285 15.1107 27.6807"
        stroke="#003E4C"
        strokeWidth="1.00404"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02631 19.5493H26.9344C27.2888 16.3246 26.0065 13.7408 22.9818 11.8391C21.7631 11.0446 20.3401 10.6217 18.8851 10.6217C18.3738 10.5762 17.8069 10.5762 17.2956 10.5762C15.8523 10.5762 14.4395 10.9897 13.2244 11.7682C10.2318 13.6745 8.82973 16.2579 9.02631 19.5493Z"
        stroke="#003E4C"
        strokeWidth="1.00404"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Umbrella
